import React from "react";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { EyeIcon } from "lucide-react";
import { Tooltip } from "react-tooltip";
import TableHeader from "../Utility/TableHeader";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { Pagination } from "../../helper/HelperTwo";
import axios from "axios";
import { toast } from "react-toastify";

function LeadRoleList({
  fetchLeadRoleData,
  leadRoleData,
  setOpenLeadRoleDialog,
  setFormData,
  setLoading,
  setEditRoleIdCrypt,
  setSaveBtn,
  rolePermission,
  paginationLeadRole,
  setCurrentPage
  
}) {
  const headers = ["S No", "Name", "Colors", "Action"];
  const user = JSON.parse(localStorage.getItem("user"));

  const handleEditForRole = async (id_crypt) => {


    setLoading(true);
    setEditRoleIdCrypt(id_crypt);
    setOpenLeadRoleDialog(true);
    setSaveBtn("update");

    try {
      const response = await axios.get(
        `public/api/admin/leadrole/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );



      const leadRoleData = response.data.role;
      const defaultPermissions = {
        Customer: ["viewOwn", "create", "edit", "delete", "view"],
        Products: ["viewOwn", "create", "edit", "delete", "view"],
        Employee: ["viewOwn", "create", "edit", "delete", "view"],
        Lead: [
          "viewOwn",
          "create",
          "edit",
          "delete",
          "convertToCustomer",
          "view",
        ],
        LeadTask: ["viewOwn", "create", "edit", "delete", "discussion", "view"],
        Quotation: ["viewOwn", "create", "edit", "delete", "pdf", "view"],
        Settings: [
          "viewOwn",
          "branch",
          "taskStatus",
          "taskPriority",
          "leadStatus",
          "leadSource",
          "taskDiscussionStatus",
          "quotationStatus",
          "roles",
          "rolesAssign"
        ],
      };

      const mapAccess = (accessArray, labelKey, defaultLabels) => {

        const accessMap = accessArray.reduce((acc, access) => {
          const labelName = access[labelKey]?.name;
          const labelValue = !!access.label_value;
          if (labelName) {
            acc[labelName.toLowerCase().replace(/\s|[()]/g, "")] = labelValue; // Normalize label names
          }
          return acc;
        }, {});

        return defaultLabels.reduce((acc, label) => {
          const normalizedLabel = label.toLowerCase().replace(/\s|[()]/g, "");
          acc[label] = accessMap[normalizedLabel] ?? false;
          return acc;
        }, {});
      };

      // Set form data, ensuring API values overwrite defaults where available
      setFormData({
        name: leadRoleData.name || "",
        color: leadRoleData.color || "#000000",
        permissions: {
          Customer: mapAccess(
            leadRoleData.customer_role_based_access || [],
            "customer_role_based_access_label",
            defaultPermissions.Customer
          ),
          Products: mapAccess(
            leadRoleData.product_role_based_access || [],
            "product_role_based_access_label",
            defaultPermissions.Products
          ),
          Employee: mapAccess(
            leadRoleData.employee_role_based_access || [],
            "employee_role_based_access_label",
            defaultPermissions.Employee
          ),
          Lead: mapAccess(
            leadRoleData.lead_role_based_access || [],
            "lead_role_based_access_label",
            defaultPermissions.Lead
          ),
          LeadTask: mapAccess(
            leadRoleData.task_role_based_access || [],
            "task_role_based_access_label",
            defaultPermissions.LeadTask
          ),
          Quotation: mapAccess(
            leadRoleData.quotation_role_based_access || [],
            "quotation_role_based_access_label",
            defaultPermissions.Quotation
          ),
          Settings: mapAccess(
            leadRoleData.settings_role_based_access || [],
            "settings_role_based_access_label",
            defaultPermissions.Settings
          ),
        
        },
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch role data");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);

      setCurrentPage(newPage);
      fetchLeadRoleData(newPage);
    }
  };

  return (
    <div className="grid md:grid-cols-1 gap-4">
      <div className="overflow-x-auto">
        <table className="min-w-full max-w-full divide-y divide-gray-300 mt-8">
          <TableHeader headers={headers} />
          <tbody className="divide-y divide-gray-200 bg-white">
            {paginationLeadRole?.data?.map((role, index) => (
              <tr
                key={index}
                className="hover:bg-gray-50 transition duration-300 ease-in-out"
              >
                <td className="py-4 px-4 text-center text-md  whitespace-nowrap font-medium">
                  {index + 1}
                </td>
                <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                  {role.name}
                </td>
                <td className="py-4 px-4 flex items-center justify-center text-center text-md uppercase whitespace-nowrap gap-2">
                  <span
                    style={{
                      backgroundColor: role.color,
                      width: "16px",
                      height: "16px",
                      borderRadius: "4px",
                    }}
                  ></span>
                </td>
                <td className="py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                  <div className="flex items-center justify-center space-x-2">
                    {rolePermission && (
                      <span
                        className="my-anchor-edit relative group cursor-pointer bg-green-400 rounded-md p-1"
                        onClick={() => handleEditForRole(role.id_crypt)}
                      >
                        <PencilSquareIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-edit"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Edit
                        </Tooltip>
                      </span>
                    )}

                    {rolePermission && (
                      <DeleteConfirmation
                        id_crypt={role.id_crypt}
                        apiType="role"
                        fetchClientData={fetchLeadRoleData}
                        setLoading={setLoading}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {paginationLeadRole && (
      <Pagination
      links={paginationLeadRole.links}
      currentPage={paginationLeadRole.current_page}
      totalResults={paginationLeadRole.total}
      from={paginationLeadRole.from}
      to={paginationLeadRole.to}
      lastPage={paginationLeadRole.last_page}
      onPageChange={handlePageChange}
      />
      )}
    </div>
  );
}

export default LeadRoleList;
